import RangeToColorConverterBase from "./RangeToColorConverterBase.js";
import RGBA from '../../valueObjects/RGBA.js';

class ConditionalRangeToColorConverter extends RangeToColorConverterBase{
    constructor(rangeFrom, rangeTo, color, fallbackConverter) {
        super();

        if (typeof(rangeFrom) !== 'number'){
            throw new TypeError('rangeFrom must be an number');
        }

        if (typeof(rangeTo) !== 'number'){
            throw new TypeError('rangeTo must be an number');
        }

        if (rangeFrom > rangeTo){
            throw new Error('rangeTo must be greater than or equal to rangeFrom');
        }

        if (!(color instanceof RGBA)) {
            throw new TypeError('color must be instance inheriting from RGBA class');
        }

        if (!(fallbackConverter instanceof RangeToColorConverterBase)) {
            throw new TypeError('fallbackConverter must be instance inheriting from RangeToColorConverterBase class');
        }

        this.from = rangeFrom;
        this.to = rangeTo;
        this.color = color;
        this.fallbackConverter = fallbackConverter;
    }

    getColor(from, to, min, max){
        if (from >= this.from && to <= this.to){
            return this.color;
        }

        return this.fallbackConverter.getColor(from, to, min, max);
    }
}

export default ConditionalRangeToColorConverter;